module.exports = __webpack_public_path__ + "img/200.4cc896a3.png";